<template>
    <div>
        <NuxtPage />
    </div>
</template>

<script setup lang="ts">
    import {use3rdParties, useHTMLAttrsLang, useSeoMeta, useTranslation} from '#imports';

    use3rdParties();
    useHTMLAttrsLang();

    const {t} = useTranslation();
    const description = t('seo.malt.meta.description');

    useSeoMeta({
        description,
        robots: 'noindex, nofollow',
    });
</script>
